import { render, staticRenderFns } from "./RefreshDialog.vue?vue&type=template&id=f2d4afd0&"
import script from "./RefreshDialog.vue?vue&type=script&lang=js&"
export * from "./RefreshDialog.vue?vue&type=script&lang=js&"
import style0 from "./RefreshDialog.vue?vue&type=style&index=0&id=f2d4afd0&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports